import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createRecipient, deleteRecipient, getOrCreateRecipient, getRecipient, queryRecipients, updateRecipient } from '@wix/ambassador-individual-scheduling-assistant-v1-recipient/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { RecipientClientBase } from './RecipientClientBase';
export class RecipientClient extends HttpBaseClient(RecipientClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getRecipientImpl", getRecipient);
    _defineProperty(this, "queryRecipientsImpl", queryRecipients);
    _defineProperty(this, "createRecipientImpl", createRecipient);
    _defineProperty(this, "getOrCreateRecipientImpl", getOrCreateRecipient);
    _defineProperty(this, "updateRecipientImpl", updateRecipient);
    _defineProperty(this, "deleteRecipientImpl", deleteRecipient);
  }
}
//# sourceMappingURL=RecipientClientHttp.js.map